import { BACKEND_ROUTES } from "../../backendRoutes";
import useSWRImmutable from "swr/immutable";

export const useSystemModels = () =>
    useSWRImmutable(`${BACKEND_ROUTES.SYSTEM_MODEL}?sort=name`);
